import {gql} from 'apollo-boost'

export const GET_CATEGORIES = gql`
    query {
        categories {
            id
            name
        }
    }
`

export const ADD_CATEGORY = gql`
    mutation($name: String!) {
        createCategory(name: $name) {
            id
            name
        }
    }
`

export const UPDATE_CATEGORY = gql`
    mutation($id: ID! $name: String!) {
        updateCategory(id: $id name: $name) {
            id
            name
        }
    }
`

export const DELETE_CATEGORY = gql`
    mutation($id: ID!) {
        deleteCategory(id: $id) {
            id
            name
        }
    }
`